import { EEOccupationalLevel, DemographicGroup } from '../../../../Component/Model/Enum/EmploymentEquity';
import { RaceTypes, Gender, MovementTypes } from '../../../../Component/Model/Enum/BEE123Enums';

export const occupationalLevelDisplayNames: Record<EEOccupationalLevel, string> = {
    [EEOccupationalLevel.Unspecified]:       'Unspecified',
    [EEOccupationalLevel.Top_Management]:    'Top Management',
    [EEOccupationalLevel.Senior_Management]: 'Senior Management',
    [EEOccupationalLevel.Middle_Management]: 'Middle Management',
    [EEOccupationalLevel.Junior_Management]: 'Junior Management',
    [EEOccupationalLevel.Semi_Skilled]:      'Semi-Skilled',
    [EEOccupationalLevel.Unskilled]:         'Unskilled',
    [EEOccupationalLevel.Temporary]:         'Temporary',
};

export const occupationalLevels: EEOccupationalLevel[] = [
    EEOccupationalLevel.Top_Management,
    EEOccupationalLevel.Senior_Management,
    EEOccupationalLevel.Middle_Management,
    EEOccupationalLevel.Junior_Management,
    EEOccupationalLevel.Semi_Skilled,
    EEOccupationalLevel.Unskilled,
];

export const raceDisplayNames: Record<number, string> = {
    [RaceTypes.African]:  'African',
    [RaceTypes.Coloured]: 'Coloured',
    [RaceTypes.Indian]:   'Indian',
    [RaceTypes.White]:    'White',
    [RaceTypes.NonRSA]:   'Foreign National',
};

export const genderDisplayNames: Record<number, string> = {
    [Gender.Male]:   'Male',
    [Gender.Female]: 'Female',
};

export const movementTypeDisplayNames: Record<number, string> = {
    [MovementTypes.Recruitment]: 'Recruitment',
    [MovementTypes.Promotion]:   'Promotion',
    [MovementTypes.Termination]: 'Termination',
};

export function demographicGroupLabel(raceId: number, genderId: number): string {
    const group: DemographicGroup | undefined = raceToDemographic[raceId]?.[genderId];
    if (group) return group;
    return `${raceDisplayNames[raceId] ?? 'Unspecified'} ${genderDisplayNames[genderId] ?? ''}`.trim();
}

export function formatRelativeGap(value: number | null | undefined): string {
    if (value === null || value === undefined) return 'N/A';
    const sign: string = value > 0 ? '+' : '';
    return `${sign}${value.toFixed(1)}%`;
}

export const raceToDemographic: Record<number, Record<number, DemographicGroup>> = {
    [RaceTypes.African]:  { [Gender.Male]: DemographicGroup.African_Male,          [Gender.Female]: DemographicGroup.African_Female },
    [RaceTypes.Coloured]: { [Gender.Male]: DemographicGroup.Coloured_Male,         [Gender.Female]: DemographicGroup.Coloured_Female },
    [RaceTypes.Indian]:   { [Gender.Male]: DemographicGroup.Indian_Male,           [Gender.Female]: DemographicGroup.Indian_Female },
    [RaceTypes.White]:    { [Gender.Male]: DemographicGroup.White_Male,            [Gender.Female]: DemographicGroup.White_Female },
    [RaceTypes.NonRSA]:   { [Gender.Male]: DemographicGroup.Foreign_National_Male, [Gender.Female]: DemographicGroup.Foreign_National_Female },
};
